import React from 'react'
import { LI, UL } from '../../../../../AbstractElements'

export default function CommenUL() {
    return (
        <UL className="simple-list flex-row">
            <LI></LI>
            <LI></LI>
            <LI></LI>
        </UL>
    )
}
